import React from 'react';
import MasterCrud from './MasterCrud';

export default function Plants() {
  return (
    <MasterCrud
      title="Plants"
      endpoint="/api/master/plants"
      columns={[
        { key: 'code', label: 'Code' },
        { key: 'name', label: 'Name' },
        { key: 'address', label: 'Address' },
        { key: 'updatedAt', label: 'Last updated' },
      ]}
      formFields={[
        { key: 'code', label: 'Code', required: true },
        { key: 'name', label: 'Name', required: true },
        { key: 'address', label: 'Address' },
      ]}
    />
  );
}
